import { gql } from '@apollo/client';
export const ASSOCIATE_PAYMENT_TO_INVOICE = ("__gql__", "{\"kind\":\"Document\",\"definitions\":[{\"kind\":\"OperationDefinition\",\"operation\":\"mutation\",\"name\":{\"kind\":\"Name\",\"value\":\"AssociatePaymentToInvoice\"},\"variableDefinitions\":[{\"kind\":\"VariableDefinition\",\"variable\":{\"kind\":\"Variable\",\"name\":{\"kind\":\"Name\",\"value\":\"invoiceObjectId\"}},\"type\":{\"kind\":\"NonNullType\",\"type\":{\"kind\":\"NamedType\",\"name\":{\"kind\":\"Name\",\"value\":\"Long\"}}}},{\"kind\":\"VariableDefinition\",\"variable\":{\"kind\":\"Variable\",\"name\":{\"kind\":\"Name\",\"value\":\"commercePaymentObjectId\"}},\"type\":{\"kind\":\"NonNullType\",\"type\":{\"kind\":\"NamedType\",\"name\":{\"kind\":\"Name\",\"value\":\"Long\"}}}}],\"selectionSet\":{\"kind\":\"SelectionSet\",\"selections\":[{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"createCrmObjectAssociationBySpec\"},\"arguments\":[{\"kind\":\"Argument\",\"name\":{\"kind\":\"Name\",\"value\":\"input\"},\"value\":{\"kind\":\"ObjectValue\",\"fields\":[{\"kind\":\"ObjectField\",\"name\":{\"kind\":\"Name\",\"value\":\"fromObjectTypeAndId\"},\"value\":{\"kind\":\"ObjectValue\",\"fields\":[{\"kind\":\"ObjectField\",\"name\":{\"kind\":\"Name\",\"value\":\"objectTypeId\"},\"value\":{\"kind\":\"StringValue\",\"value\":\"0-53\",\"block\":false}},{\"kind\":\"ObjectField\",\"name\":{\"kind\":\"Name\",\"value\":\"objectId\"},\"value\":{\"kind\":\"Variable\",\"name\":{\"kind\":\"Name\",\"value\":\"invoiceObjectId\"}}}]}},{\"kind\":\"ObjectField\",\"name\":{\"kind\":\"Name\",\"value\":\"toObjectTypeAndId\"},\"value\":{\"kind\":\"ObjectValue\",\"fields\":[{\"kind\":\"ObjectField\",\"name\":{\"kind\":\"Name\",\"value\":\"objectTypeId\"},\"value\":{\"kind\":\"StringValue\",\"value\":\"0-101\",\"block\":false}},{\"kind\":\"ObjectField\",\"name\":{\"kind\":\"Name\",\"value\":\"objectId\"},\"value\":{\"kind\":\"Variable\",\"name\":{\"kind\":\"Name\",\"value\":\"commercePaymentObjectId\"}}}]}},{\"kind\":\"ObjectField\",\"name\":{\"kind\":\"Name\",\"value\":\"associationSpecs\"},\"value\":{\"kind\":\"ObjectValue\",\"fields\":[{\"kind\":\"ObjectField\",\"name\":{\"kind\":\"Name\",\"value\":\"associationCategory\"},\"value\":{\"kind\":\"EnumValue\",\"value\":\"HUBSPOT_DEFINED\"}},{\"kind\":\"ObjectField\",\"name\":{\"kind\":\"Name\",\"value\":\"associationTypeId\"},\"value\":{\"kind\":\"IntValue\",\"value\":\"541\"}}]}}]}}],\"selectionSet\":{\"kind\":\"SelectionSet\",\"selections\":[{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"createFailures\"},\"selectionSet\":{\"kind\":\"SelectionSet\",\"selections\":[{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"failReason\"}}]}}]}}]}}]}", {
  id: null,
  kind: "Document",
  definitions: [{
    kind: "OperationDefinition",
    operation: "mutation",
    name: {
      kind: "Name",
      value: "AssociatePaymentToInvoice"
    },
    variableDefinitions: [{
      kind: "VariableDefinition",
      variable: {
        kind: "Variable",
        name: {
          kind: "Name",
          value: "invoiceObjectId"
        }
      },
      type: {
        kind: "NonNullType",
        type: {
          kind: "NamedType",
          name: {
            kind: "Name",
            value: "Long"
          }
        }
      }
    }, {
      kind: "VariableDefinition",
      variable: {
        kind: "Variable",
        name: {
          kind: "Name",
          value: "commercePaymentObjectId"
        }
      },
      type: {
        kind: "NonNullType",
        type: {
          kind: "NamedType",
          name: {
            kind: "Name",
            value: "Long"
          }
        }
      }
    }],
    selectionSet: {
      kind: "SelectionSet",
      selections: [{
        kind: "Field",
        name: {
          kind: "Name",
          value: "createCrmObjectAssociationBySpec"
        },
        arguments: [{
          kind: "Argument",
          name: {
            kind: "Name",
            value: "input"
          },
          value: {
            kind: "ObjectValue",
            fields: [{
              kind: "ObjectField",
              name: {
                kind: "Name",
                value: "fromObjectTypeAndId"
              },
              value: {
                kind: "ObjectValue",
                fields: [{
                  kind: "ObjectField",
                  name: {
                    kind: "Name",
                    value: "objectTypeId"
                  },
                  value: {
                    kind: "StringValue",
                    value: "0-53",
                    block: false
                  }
                }, {
                  kind: "ObjectField",
                  name: {
                    kind: "Name",
                    value: "objectId"
                  },
                  value: {
                    kind: "Variable",
                    name: {
                      kind: "Name",
                      value: "invoiceObjectId"
                    }
                  }
                }]
              }
            }, {
              kind: "ObjectField",
              name: {
                kind: "Name",
                value: "toObjectTypeAndId"
              },
              value: {
                kind: "ObjectValue",
                fields: [{
                  kind: "ObjectField",
                  name: {
                    kind: "Name",
                    value: "objectTypeId"
                  },
                  value: {
                    kind: "StringValue",
                    value: "0-101",
                    block: false
                  }
                }, {
                  kind: "ObjectField",
                  name: {
                    kind: "Name",
                    value: "objectId"
                  },
                  value: {
                    kind: "Variable",
                    name: {
                      kind: "Name",
                      value: "commercePaymentObjectId"
                    }
                  }
                }]
              }
            }, {
              kind: "ObjectField",
              name: {
                kind: "Name",
                value: "associationSpecs"
              },
              value: {
                kind: "ObjectValue",
                fields: [{
                  kind: "ObjectField",
                  name: {
                    kind: "Name",
                    value: "associationCategory"
                  },
                  value: {
                    kind: "EnumValue",
                    value: "HUBSPOT_DEFINED"
                  }
                }, {
                  kind: "ObjectField",
                  name: {
                    kind: "Name",
                    value: "associationTypeId"
                  },
                  value: {
                    kind: "IntValue",
                    value: "541"
                  }
                }]
              }
            }]
          }
        }],
        selectionSet: {
          kind: "SelectionSet",
          selections: [{
            kind: "Field",
            name: {
              kind: "Name",
              value: "createFailures"
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "failReason"
                }
              }]
            }
          }]
        }
      }]
    }
  }]
});